module.exports = __webpack_public_path__ + "img/专精特新小巨人.c1bf68e0.jpg";